
import { IonButton, IonContent } from "@ionic/vue";
import { defineComponent } from "vue";
import BannerComponent from "../components/BannerComponent.vue";

export default defineComponent({
  name: "Logout",
  components: { IonButton, IonContent },
});
